// ======================Auth==
export const LOGIN = 'LOGIN';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

 

//=========================Loader
export const LOADING = 'LOADING';
export const LOADED = 'LOADED';



// =========================RESET
export const RESET_MESSAGES = 'RESET_MESSAGES';
export const RESET_SUCCESS = 'RESET_SUCCESS';


// ========================================Message
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';


// =======================Validation Error=================
export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const VALIDATION_AUTH_ERROR = "VALIDATION_AUTH_ERROR";


// =======================Download Error=================
export const TOTAL_SIZE = "TOTAL_SIZE";
export const DOWNLOADED = "DOWNLOADED";
export const PERCENT = "PERCENT";